/* RESPONSIBLE TEAM: team-inbox */
import { DataType } from 'embercom/objects/inbox/conversation-attribute-descriptor';
import type TicketAttributeSummary from 'embercom/objects/inbox/ticket-attribute-summary';
import { type TicketAttributeSummaryValue } from 'embercom/objects/inbox/ticket-attribute-summary';

export function serializeTicketAttributes(
  ticketAttributes: TicketAttributeSummary[],
): Record<string, unknown> {
  let attributes: Record<string, unknown> = {};

  for (let attr of ticketAttributes) {
    if (attr.descriptor.dataType !== DataType.Files && attr.value !== undefined) {
      attributes[attr.descriptor.name] = attr.value;
    }
  }

  return attributes;
}

export function restoreTicketDraftAttributes(
  draftAttributes: Record<string, unknown>,
  ticketAttributes: TicketAttributeSummary[],
): boolean {
  let restored = false;

  for (let attr of ticketAttributes) {
    if (attr.descriptor.dataType !== DataType.Files) {
      let draftValue = draftAttributes[attr.descriptor.name];
      if (draftValue !== undefined) {
        attr.value = draftValue as TicketAttributeSummaryValue;
        restored = true;
      }
    }
  }

  return restored;
}
